"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgOpenDoor = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M5.999 2H17.99c1.333 0 2 .667 2.004 2v15.996c-.003 1.33-.671 1.998-2.004 2.004-1.998.009-9.982.009-11.996 0-1.342-.006-2.007-.674-1.995-2.004V4C4 2.667 4.666 2 6 2h-.001zm7.731 13.754c-.172.311-.455.577-.848.797L6 20.005h12v-16h-3.972l-.043 10.766a1.97 1.97 0 01-.255.983zM10.995 10a1 1 0 100-2 1 1 0 000 2z' }))); };
exports.default = SvgOpenDoor;
//# sourceMappingURL=OpenDoor.js.map